import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useAssetFilter = makeStyles((theme: Theme) => ({
  option: {
    "&:hover": {
      backgroundColor: `${theme?.palette.customColor.BGLIGHT} !important`,
    },
  },
  contentcontroler: {
    width: "100%",
    wordBreak: "break-all",
  },
  searchinputandor: {
    marginLeft: "10px",
    filter: "brightness(0)",
  },
  option1: {
    "&:hover": {
      backgroundColor: `${theme?.palette.customColor.BGLIGHT} !important`,
    },
  },
  contentcontrol: {
    width: "94.5%",
    maxWidth: "500px",
    wordBreak: "break-all",
  },
  inputadorbox: {
    marginLeft: "10px",
    filter: "brightness(0)",
  },
}));
